import { render } from "./SpotAssignHistoryModal.vue?vue&type=template&id=7b4fca60&ts=true"
import script from "./SpotAssignHistoryModal.vue?vue&type=script&lang=ts"
export * from "./SpotAssignHistoryModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__